export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    big_win: [
      0,
      4019.2970521541947,
    ],
    button_spin: [
      6000,
      526.5986394557824,
    ],
    buy_button: [
      8000,
      2594.7619047619046,
    ],
    end_free_spin: [
      12000,
      2750,
    ],
    free_bet_big_win: [
      16000,
      1362.3129251700695,
    ],
    free_bet_mega_win: [
      19000,
      2207.913832199548,
    ],
    free_bet_total_win: [
      23000,
      973.3560090702938,
    ],
    free_bet_ultra_win: [
      25000,
      1297.4149659863947,
    ],
    free_spin_ambient: [
      28000,
      29244.353741496598,
    ],
    free_spin_popup: [
      59000,
      2750,
    ],
    free_spin_start: [
      63000,
      4346.167800453514,
    ],
    inside_buttons: [
      69000,
      236.5079365079339,
    ],
    main_ambient: [
      71000,
      61869.59183673468,
    ],
    mega_win: [
      134000,
      3958.2539682539564,
    ],
    outside_buttons: [
      139000,
      340.7029478458128,
    ],
    reel_spin: [
      141000,
      2529.5691609977384,
    ],
    reel_stop_01: [
      145000,
      210.09070294783783,
    ],
    reel_stop_02: [
      147000,
      201.72335600906877,
    ],
    reel_stop_03: [
      149000,
      192.65306122449033,
    ],
    reel_stop_04: [
      151000,
      251.0657596371857,
    ],
    reel_stop_05: [
      153000,
      171.33786848071964,
    ],
    regular_win: [
      155000,
      555.464852607713,
    ],
    scatter_chance: [
      157000,
      2271.473922902487,
    ],
    tap_to_play: [
      161000,
      4257.36961451247,
    ],
    ultra_win: [
      167000,
      3719.2743764172465,
    ],
  },
}
